import { IoIosMail } from "react-icons/io";
import { Product } from "../../../../../graphql/operations";
import { Text } from "../../../../Atoms/Typography";
import WaitingListButton, {
  WaitingListButtonProps,
} from "../../../../Cards/WaitingListButton";
import { WaitingListModalProps } from "../../../../Cards/WaitingListModal";

type ProductWaitingListButtonProps = {
  productId?: Product["id"];
  email?: string;
  phoneNumber?: string;
} & Partial<Pick<WaitingListModalProps, "productOptions">> &
  Pick<WaitingListButtonProps, "style">;

export default function ProductWaitingListButton({
  email,
  phoneNumber,
  productId,
  productOptions,
  style,
  children,
}: React.PropsWithChildren<ProductWaitingListButtonProps>) {
  return (
    <WaitingListButton
      style={{ ...{ width: "100%", textAlign: "center" }, ...style }}
      email={email}
      phoneNumber={phoneNumber}
      productId={productId}
      productOptions={productOptions}
    >
      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          cursor: "pointer",
          position: "relative",
        }}
      >
        <IoIosMail
          color="#00bfa5"
          size={32}
          style={{ position: "absolute", left: "-40px" }}
        />
        <div style={{ textAlign: "center" }}>
          <p style={{ marginBottom: "6px" }}>
            {children ?? "Not available yet?"}
          </p>
          <Text bold underline>
            Join the waiting list
          </Text>
        </div>
      </div>
    </WaitingListButton>
  );
}
